export { getLocale } from './get-locale';
export type { Locale } from './type';
